export default class DnTab {
  init() {

    const $tabs = $('.mdToggleTab');
    if (!$tabs.get(0)) return;

    // 初期表示
    $tabs.each(function() {
      var $el  = $(this),
          init = $el.data('init');

      $('.mdToggleBody[data-index="' + init + '"]').css('display', 'table-row-group');
      $('.mdToggleTab a[data-target="' + init + '"]').parent().addClass('current');
    });

    // タブクリック
    $(document).on('click', '.mdToggleTab li a', function(e) {
      var $el = $(this);

      var $parent = $el.parent().parent(),
          now     = $parent.attr('data-init'),
          $now    = $('.mdToggleBody[data-index="' + now + '"]'),
          target  = $el.data('target'),
          $target = $('.mdToggleBody[data-index="' + target + '"]');

      $now.hide();
      $target.css('display', 'table-row-group');
      $parent.attr('data-init', target);
      $parent.find('.current').removeClass('current');
      $el.parent().addClass('current');

      return false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/manager/old-modules/modules/DnTab.js